import { message } from 'antd'
import axios from 'axios'
import { oauth2Agent } from 'context/AuthContext'

const api = axios.create({
  baseURL: process.env.REACT_APP_API_CZRM,
  headers: {
    Authorization: '',
  },
})

const TOKEN = `${process.env.REACT_APP_DEMO_APP_KEY ?? ''}_token`

api.interceptors.request.use((config) => {
  const token = localStorage.getItem(TOKEN)

  if (token !== null) {
    return {
      ...config,
      headers: {
        ...(config.headers ?? {}),
        Authorization: token,
      },
    }
  }
})
const mapResponseToUsefulData = () => {
  function myEvent() {
    const event = new Event('myEventRequest')

    document.dispatchEvent(event)
  }
  myEvent()
}

api.interceptors.response.use(
  (response) => {
    mapResponseToUsefulData()
    return response
  },
  async (error) => {
    const { response } = error
    if (response === undefined) {
      message.error('Seu token foi expirado. Redirecionando para login...')
      oauth2Agent.logout()
    } else if (
      response?.config?.url !== 'inconsistencies' &&
      response?.config?.url !== 'family'
    ) {
      message.error(
        Boolean(response?.data?.message) ||
          'Ocorreu um erro. Entre em contato com a administração!'
      )
      return await Promise.reject(error)
    }
    return await Promise.reject(error)
  }
)

export default api
